// AuthenticatedRouteWrapper.js
import React from 'react';
import { Redirect } from 'react-router-dom';
import { useAuthContext } from '../hooks/useAuthContext';

const AuthenticatedRouteWrapper = ({ children }) => {
  const { user } = useAuthContext();

  if (!user) {
    console.log('Redirecting to login...'); // Add this line for debugging
    return <Redirect to="/login" />;
  }

  return <>{children}</>;
};

export default AuthenticatedRouteWrapper;
